import _sfc_main from "./component-library106.mjs";
import "./component-library107.mjs";
import normalizeComponent from "./component-library81.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  _vm._self._setupProxy;
  return _c("div", { staticClass: "input-wrapper", class: _vm.wrapperClass }, [_vm.label || _vm.showLabel ? _c("label", { staticClass: "input-wrapper__label", class: _vm.labelClass, attrs: { "for": _vm.id } }, [_vm._t("label", function() {
    return [_vm._v(" " + _vm._s(_vm.label) + " "), _vm.required ? _c("span", { staticClass: "input-wrapper__required" }, [_vm._v("*")]) : _vm._e()];
  }, { "id": _vm.id })], 2) : _vm._e(), _vm._t("default", null, { "id": _vm.id }), _vm.hasError ? _c("p", { staticClass: "input-wrapper__error-message" }, [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]) : _vm._e()], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "8c0a3517",
  null,
  null
);
const InputWrapper = __component__.exports;
export {
  InputWrapper as default
};
